// Lists the types of dates used to record when an assessment for a grade was
// undertaken. Can be a year, month+year, or day+month+year.
export default {
  YEAR: 'YEAR',
  SESSION: 'SESSION',
  DATE: 'DATE',
};
